export function getThreadUserDisplayUser(threadUser, employeesStore) {
    const threadUserRecord = threadUser?.user || {};
    const employeeUser = employeesStore.getEmployeeById(
        threadUser?.user_id || threadUserRecord.id
    );

    return {
        ...threadUserRecord,
        ...employeeUser,
        profile_image_id:
            employeeUser?.profile_image_id || threadUserRecord.profile_image_id,
        hash: employeeUser?.hash || threadUserRecord.hash,
    };
}
